/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { updateTagComputedCustom } from '../fn/tag/update-tag-computed-custom';
import { UpdateTagComputedCustom$Params } from '../fn/tag/update-tag-computed-custom';

@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateTagComputedCustom()` */
  static readonly UpdateTagComputedCustomPath = '/custom/tags-computed/{uid}';

  /**
   * Update an existing Computed tags.
   *
   * Update an existing Computed tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTagComputedCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagComputedCustom$Response(params: UpdateTagComputedCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTagComputedCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing Computed tags.
   *
   * Update an existing Computed tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTagComputedCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTagComputedCustom(params: UpdateTagComputedCustom$Params, context?: HttpContext): Observable<void> {
    return this.updateTagComputedCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
